module.exports = __webpack_public_path__ + "static/media/icon-pill-padel.ed81fff3.svg";